// extracted by mini-css-extract-plugin
export default {"mainBody":"index_mainBody_kMbow","cmt_past":"index_cmt_past_rOXiO clearfix","cmtBox":"index_cmtBox_zQgRS","footer":"index_footer_i9aFR"};